import { AxiosInstance } from "axios";
import { createContext, useContext } from "react";

interface ApiContextType {
  client: AxiosInstance;
  abort: () => void;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

const useApiContext = () => {
  // get the context
  const context = useContext(ApiContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useApiContext was used outside of its Provider");
  }

  return context;
};

export { ApiContext, useApiContext };
